<template>
    <footer class="bg-white py-2">
        <div class="copyright text-center my-auto">
            <span>Operation & Maintenance by Computer Network Systems Ltd. CNS &copy; {{ year }}</span>
        </div>
    </footer>
</template>

<script>


export default {
    data() {
        return {
            year: (new Date()).getFullYear(),
        }
    },
    name: 'FooterPage',
    props:['system'],
    /*mounted() {
        LookupService.getCurrentYear().then(({data}) => {
            this.year = data.year
        })
    }*/
}
</script>

<style>

</style>